import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=4e5b7904"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports